import { fetch } from '../fetchWrapper/fetch';
import { EXTENSIONS_API_URL } from '../../constants';

export const deleteExtension = async (brandId: string, extensionId: string): Promise<boolean> => {
  try {
    const res = await fetch(`${EXTENSIONS_API_URL}/${extensionId}`, {
      method: 'DELETE',
      headers: {
        'brand-id': brandId,
      },
    });
    if (res.status !== 204 && res.status !== 200) {
      const errorBody = await res.json().catch(() => ({}));
      throw new Error(errorBody.message || `Request failed with status ${res.status}`);
    }
    return true;
  } catch (e) {
    if (e instanceof Error) throw e;
    throw new Error('Could not delete extension');
  }
};
